import { CompanyTitledPage } from "../../TitledPage";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import { Link, useNavigate } from "react-router-dom";

import { Pagination, Table, TableContainer, TableHead } from "@mui/material";
import { CompanyPartHeader } from "../../../components/PartHeader";

import Paper from "@mui/material/Paper";

import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { blueGrey, grey } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import SelectBox from "../../../components/SelectBox";
import useInputObject from "../../../hooks/useInputObject";
import { getProductDetail } from "../../../http/api/ProductDetailAPI";
import PrintPreview from "../../invoice/PrintManagePage/PrintPreview";
import LoadingModal from "../../../components/LoadingModal";
import { downloadProductPrintInfo } from "../../../http/api/ProductAPI";

const infoTableCellSx = {
  fontSize: 17,
};

// 検索フォーム
function ProductDetailSearchForm(props) {
  const searchForm = useInputObject({});
  
  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      商品フィルター
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs="auto">
            商品コード:&nbsp;
            <OutlinedInput
              sx={{ width: 250 }}
              onChange={(e) =>
                searchForm.handleChange(e.target.value, "productId")
              }
              value={searchForm.Value.productId}
            />
          </Grid>
          <Grid item xs="auto">
            商品名:&nbsp;
            <OutlinedInput
              sx={{ width: 300 }}
              onChange={(e) =>
                searchForm.handleChange(e.target.value, "productName")
              }
              value={searchForm.Value.productName}
            />
          </Grid>
          <Grid item xs="auto">
            仕入先コード:&nbsp;
            <OutlinedInput
              sx={{ width: 250 }}
              onChange={(e) =>
                searchForm.handleChange(e.target.value, "supplierId")
              }
              value={searchForm.Value.supplierId}
            />
          </Grid>
          <Grid item xs="auto">
            登録日:&nbsp;
            <OutlinedInput
              type="date"
              inputProps={{
                min: "1000-01-01",
                max: "9999-12-31",
              }}
              sx={{ width: 250 }}
              onChange={(e) =>
                searchForm.handleChange(e.target.value, "createdAtFrom")
              }
              value={searchForm.Value.createdAtFrom}
            />
            &nbsp;から&nbsp;
            <OutlinedInput
              type="date"
              inputProps={{
                min: "1000-01-01",
                max: "9999-12-31",
              }}
              sx={{ width: 250 }}
              onChange={(e) =>
                searchForm.handleChange(e.target.value, "createdAtTo")
              }
              value={searchForm.Value.createdAtTo}
            />
            &nbsp;まで
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={() => props.search(searchForm.Value)}
            >
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function ProductTable(props) {
  const { productDetails } = props;
  const columns = [
    "商品名",
    "部門名",
    "中分類名",
    "小分類名",
    "税種",
    "産地",
    "等級",
    "規格",
    "入数",
    "荷姿",
    "発注単位",
    "仕入先",
    "",
  ];

 
  return (
    <Fragment>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {columns.map((columnName, i) => {
                return (
                  <TableCell
                    key={`${columnName}_${i}`}
                    sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                  >
                    {columnName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {productDetails.map((data, i) => (
              <TableRow
                key={i}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                }}
              >
                {/* 商品名 */}
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    fontWeight: "bold",
                    fontSize: 20,
                    height: 28,
                    width: 300,
                  }}
                >
                  <Link
                    to={`/company/product/`}
                    state={{
                      productId: data.productId,
                    }}
                  >
                    {i > 0 && data.productId == productDetails[i - 1].productId
                      ? ""
                      : data.productName}
                  </Link>
                </TableCell>
                {/* 部門名 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.productClassLName}
                </TableCell>
                {/* 中分類 */}
                <TableCell sx={{ ...infoTableCellSx, width: 140 }}>
                  {data.productClassMName}
                </TableCell>
                {/* 小分類 */}
                <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                  {data.productClassSName}
                </TableCell>
                {/* 税率 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.taxName + " " + data.taxRate*100}%
                </TableCell>
                {/* 産地 */}
                <TableCell sx={{ ...infoTableCellSx, width: 180 }}>
                  {data.origin}
                </TableCell>
                {/* 等級 */}
                <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                  {data.rank}
                </TableCell>
                {/* 規格 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>{`${
                  data.productClass || ""
                } ${data.weight || ""}${data.weightUnit || ""}`}</TableCell>
                {/* 入数 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.quantity}
                </TableCell>
                {/* 荷姿 */}
                <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                  {data.packing}
                </TableCell>
                {/* 発注単位 */}
                <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                  {data.orderingUnit || ""}
                </TableCell>
                {/* 仕入先 */}
                <TableCell sx={{ ...infoTableCellSx, width: 200 }}>
                  {data.supplierName}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
}

export default function ProductMasterPage() {
  
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [searchCondition, setSearchCondition] = useState({});
  const [isLoading, setLoading] = useState(false);
  const printPreview = useInputObject({
    open: false,
    url: "",
  });
  useEffect(() => {
    GetProductDetails();
  }, [page, itemsPerPage, searchCondition]);
  async function GetProductDetails() {
    let params = { page: page - 1, itemsPerPage, ...searchCondition };
    try {
      let response = await getProductDetail(params);
      setProductDetails(response.listProductDetailInfo);
      setTotalQuantity(response.totalQuantity);
      console.log("set new productList");
    } catch {
      setProductDetails([]);
      setTotalQuantity(0);
    }
  }

  function handleClickSearch(searchCondition) {
    setSearchCondition(searchCondition);
    setPage(1);
  }
  async function printProduct() {
    try {
      //　ローディング　表示
      setLoading(true);
      // request to server 
      // request body 宣言
      const requestBody = {};
      // download 結果　受け取る
      const result = await downloadProductPrintInfo(requestBody);
      //印刷情報設定
      if (result) {
        const blob = new Blob([result], {
          type: "application/pdf",
          encoding: "UTF-8",
        });
        const fileUrl = URL.createObjectURL(blob);
        printPreview.updates({ open: true, url: fileUrl });
      }
    } catch (error) {

    }
    finally {
      //　ローディング　非表示
      setLoading(false);
    }

  };
  return (
    <CompanyTitledPage title="商品マスタ">
      <ProductDetailSearchForm search={handleClickSearch} />
      <CompanyPartHeader>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Typography fontWeight="bold" fontSize={20}>
              検索結果{totalQuantity > 0 ? `（件数：${totalQuantity}）` : ""}
            </Typography>
          </Grid>
          <Grid item xs="auto">

          <Button
                variant="outlined"
                onClick={printProduct}
              >
                商品一覧印刷
              </Button>
            <Button
              variant="outlined"
              onClick={() =>
                navigate(SYSTEM_PATH_COMPANY + "/product_register/")
              }
            >
              商品登録
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      <ProductTable productDetails={productDetails} />
      {/* ページング */}
      <Grid container display="flex" justifyContent="space-between" mt={3}>
        <Grid item xs={2}>
          <SelectBox
            data={[10, 50, 100].map((x) => {
              return {
                key: x,
                value: x,
              };
            })}
            onChange={(e) => {
              setItemsPerPage(e.target.value);
            }}
            value={itemsPerPage}
            sx={{ width: 400 }}
            label={"表示件数　"}
            nullable={false}
          />
        </Grid>
        <Grid item xs={8} display="flex" justifyContent="center">
          <Pagination
            count={Math.floor(totalQuantity / itemsPerPage) + 1}
            page={page}
            onChange={(e, newPage) => {
              setPage(newPage);
              console.log(newPage);
            }}
            variant="outlined"
            shape="rounded"

          />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
      <LoadingModal label="取得中" open={isLoading} />
        <PrintPreview printPreview={printPreview} />
    </CompanyTitledPage>

  );
}
